import { Fragment } from "react/jsx-runtime";
import { Grid, Typography } from "@mui/material";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

interface SimpleReportHeaderProps {
  title: string;
}

export function ReportsSimpleReportHeader({ title }: SimpleReportHeaderProps) {
  return (
    <Fragment>
      <Grid size={12}>
        <Typography variant="h4" fontWeight={700} textTransform="uppercase">
          {title}
        </Typography>
      </Grid>
      <Grid size={12}>
        <ReportsSectionHeading heading="Summary" />
      </Grid>
    </Fragment>
  );
}
